import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Col, ListGroup } from 'react-bootstrap';

import PerfectScrollBar from 'react-perfect-scrollbar';

import { MdVerifiedUser, MdPhone } from 'react-icons/md';
import { GoUnverified } from 'react-icons/go';
import {
  makeGetToken,
  makeGetAuth,
  makeGetProfile,
  makeGetDefaultAccount,
  makeGetNoiCap,
} from '../../lib/selector';
import { formatPhoneNumber, _formatDate2 } from '../../utils';
import { translate } from 'react-i18next';
class Profile extends React.Component {
  render() {
    const { auth, token, profile, defaultAccount, noicap, t } = this.props;
    console.log('profile', profile);
    return (
      <PerfectScrollBar>
        <div className="d-flex justify-content-md-center">
          <Col md="6" className="d-flex flex-column">
            <div className="d-flex justify-content-between align-items-center mt-3">
              <label className="text-white fz-18">
                {t('txt-label-account-info')}
              </label>
              <span className={'fz-14 ' + (auth.isVerified ? 'i' : 'd')}>
                {auth && auth.isVerified ? (
                  <Fragment>
                    <MdVerifiedUser className="mr-2" />
                    {t('txt-da-xacthuc')}
                  </Fragment>
                ) : (
                  <Fragment>
                    <GoUnverified className="mr-2" />
                    {t('txt-chua-xacthuc')}
                  </Fragment>
                )}
              </span>
            </div>
            <ListGroup className="mt-2">
              <ListGroup.Item className="d-flex p-2">
                <span className="fz-14 txt-content mr-auto">
                  {t('txt-label-fullname')}
                </span>
                <span className="fz-14 text-white font-weight-bold">
                  {profile && profile.custNm}
                </span>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex p-2">
                <span className="fz-14 txt-content mr-auto">
                  {t('txt-label-identification')}
                </span>
                <span className="fz-14 text-white font-weight-bold">
                  {profile && profile.custId}
                </span>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex p-2">
                <span className="fz-14 txt-content mr-auto">
                  {t('txt-label-issued-on')}
                </span>
                <span className="fz-14 text-white font-weight-bold">
                  {profile && _formatDate2(profile.custIdIssuDate)}
                </span>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex p-2">
                <span className="fz-14 txt-content mr-auto">
                  {t('txt-label-place')}
                </span>
                <span className="fz-14 text-white font-weight-bold">
                  {profile && noicap}
                </span>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex p-2">
                <span className="fz-14 txt-content mr-auto">
                  {t('txt-label-phone-num')}
                </span>
                <span className="fz-14 text-white font-weight-bold">
                  {profile && formatPhoneNumber(profile.cphnNo)}
                </span>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex p-2">
                <span className="fz-14 txt-content mr-auto">
                  {t('txt-label-date-birth')}
                </span>
                <span className="fz-14 text-white font-weight-bold">
                  {profile && _formatDate2(profile.brthdt)}
                </span>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex p-2">
                <span className="fz-14 txt-content mr-auto">
                  {t('txt-label-sex')}
                </span>
                <span className="fz-14 text-white font-weight-bold">
                  {profile &&
                    (profile.gend === 'M'
                      ? t('txt-label-male')
                      : profile.gend === 'F'
                      ? t('txt-label-female')
                      : '-')}
                </span>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex p-2">
                <span className="fz-14 txt-content mr-auto">{'Email'}</span>
                <span className="fz-14 text-white font-weight-bold">
                  {profile && profile.email}
                </span>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex p-2">
                <span className="fz-14 txt-content mr-auto">
                  {t('txt-label-cif-no')}
                </span>
                <span className="fz-14 text-white font-weight-bold">
                  {token && token.cif}
                </span>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex p-2">
                <span className="fz-14 txt-content mr-auto">
                  {t('txt-label-vsd-no')}
                </span>
                <span className="fz-14 text-white font-weight-bold">
                  {defaultAccount && defaultAccount.vsdAcntNo}
                </span>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex p-2">
                <span className="fz-14 txt-content mr-auto">
                  {t('txt-label-nationality')}
                </span>
                <span className="fz-14 text-white font-weight-bold">
                  {profile && profile.natnlNm}
                </span>
              </ListGroup.Item>
            </ListGroup>
            <label className="text-white fz-18 mt-3 mb-3">
              {t('txt-label-contact-info')}
            </label>
            <ListGroup>
              <ListGroup.Item className="d-flex p-2">
                <span className="fz-14 txt-content mr-auto">
                  {t('txt-label-permanent-address')}
                </span>
                <span className="fz-14 text-white font-weight-bold">
                  {profile && profile.perdomAddr}
                </span>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex p-2">
                <span className="fz-14 txt-content mr-auto">
                  {t('txt-label-address')}
                </span>
                <span className="fz-14 text-white font-weight-bold">
                  {profile && profile.cttAddr}
                </span>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex p-2">
                <span className="fz-14 txt-content mr-auto">
                  {t('txt-label-province')}
                </span>
                <span className="fz-14 text-white font-weight-bold">
                  {profile && profile.provNm}
                </span>
              </ListGroup.Item>
            </ListGroup>
            <p className="txt-content fz-14 mt-3 mb-3 text-center">
              {t('txt-hotline-support')}
            </p>
            <a
              href={`tel:02462823535`}
              className="text-center text-white fz-12 mb-3 mx-auto"
              style={{
                width: '120px',
                backgroundColor: '#1BA0E1',
                borderRadius: '18px',
                padding: '5px',
              }}
            >
              <MdPhone className="mr-2" />
              {'0246.282.3535'}
            </a>
          </Col>
        </div>
      </PerfectScrollBar>
    );
  }
}

const makeMapStateToProps = () => {
  const getToken = makeGetToken();
  const getAuth = makeGetAuth();
  const getDefaultAccount = makeGetDefaultAccount();
  const getProfile = makeGetProfile();
  const getNoiCap = makeGetNoiCap();

  const mapStateToProps = (state) => {
    return {
      token: getToken(state),
      auth: getAuth(state),
      defaultAccount: getDefaultAccount(state),
      profile: getProfile(state),
      noicap: getNoiCap(state),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(translate('translations')(Profile));
